import React from "react";
//import Floater from "react-floater";
import WithText from "./WithText";

const SwotInfo = () => {
  return (
    <>
      <div>
        <WithText></WithText>
      </div>
    </>
  );
};

export default SwotInfo;
